<template>
  <router-view />
</template>

<script>
import { unRegisterMixin } from '@/mixin/storeGenerator';

export default {
  name: 'WrapperRLV',
  mixins: [unRegisterMixin],
  data() {
    return {
      moduleName: 'BooksCatalogModule',
    };
  },
};
</script>
